"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconButtonSizeConfig = exports.StyledIconButton = void 0;
var _AccountCircle = _interopRequireDefault(require("@tvg/fuse-icons/lib/AccountCircle"));
var _react = _interopRequireDefault(require("react"));
var _server = require("react-dom/server");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _gridConfig = require("../../fuse-responsive-grid/src/grid-config");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
var sizeConfig = exports.iconButtonSizeConfig = {
  small: {
    fontSize: 'var(--font-size-m2)',
    // Multiplying by 1.6 due to root font-size of page being 10px and rounding to 1 decimal place. Original icon size is 24px
    iconHeight: "".concat(Math.round(24 / 16 * 1.6 * 10) / 10, "rem"),
    iconWidth: "".concat(Math.round(24 / 16 * 1.6 * 10) / 10, "rem"),
    lineHeight: 'var(--font-line-height-m2)'
  },
  medium: {
    fontSize: 'var(--font-size-m1)',
    // Multiplying by 1.6 due to root font-size of page being 10px and rounding to 1 decimal place. Original icon size is 32px
    iconHeight: "".concat(Math.round(32 / 16 * 1.6 * 10) / 10, "rem"),
    iconWidth: "".concat(Math.round(32 / 16 * 1.6 * 10) / 10, "rem"),
    lineHeight: 'var(--font-line-height-m1)'
  },
  large: {
    fontSize: 'var(--font-size-1)',
    // Multiplying by 1.6 due to root font-size of page being 10px and rounding to 1 decimal place. Original icon size is 40px
    iconHeight: "".concat(Math.round(40 / 16 * 1.6 * 10) / 10, "rem"),
    iconWidth: "".concat(Math.round(40 / 16 * 1.6 * 10) / 10, "rem"),
    lineHeight: 'var(--font-line-height-1)'
  }
};
var iconSizeCSS = function iconSizeCSS(size) {
  return "\n\t\twidth: ".concat(sizeConfig[size].iconWidth, ";\n\t\theight: ").concat(sizeConfig[size].iconHeight, ";\n\t");
};
var fontSizeCSS = function fontSizeCSS(size) {
  return "font: var(--font-weight-paragraph) ".concat(sizeConfig[size].fontSize, " / ").concat(sizeConfig[size].lineHeight, "  var(--font-brand)");
};
var getViewportCSS = function getViewportCSS(size, callback) {
  return typeof size === 'string' ? callback(size) : Object.entries(size).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      viewport = _ref2[0],
      value = _ref2[1];
    return " @media screen and (min-width: ".concat(_gridConfig.gridConfig[viewport].minWidth, ") {\n\t\t\t\t").concat(callback(value), "\n\t\t\t  }");
  }).join('');
};
var StyledIconButton = exports.StyledIconButton = _styledComponents["default"].a.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'icon';
  }
}).withConfig({
  displayName: "styled-icon-button__StyledIconButton",
  componentId: "sc-vwrlez-0"
})(["", ""], function (_ref3) {
  var icon = _ref3.icon,
    size = _ref3.size;
  var SvgIcon = icon || /*#__PURE__*/_react["default"].createElement(_AccountCircle["default"], null);
  return "\n        display: inline-flex;\n        flex-direction: column;\n        color: var(--color-global-grey900);\n        align-items: center;\n        text-decoration: none;\n        padding: 0 var(--spacing-global-space1);\n        position: relative;\n\n        &:hover,\n        &:focus {\n            color: var(--color-brand-dark);\n            cursor: pointer;\n        }\n\n        &:focus {\n            outline: var(--spacing-global-space1) solid var(--color-functional-focus);\n        }\n\n        &:active {\n            color: var(--color-global-black);\n        }\n\n        &:focus:before,\n        &:hover:before {\n            background: var(--color-brand-dark);\n        }\n\n        &:active:before {\n            background: var(--color-global-black);\n        }\n\n        & span {\n            border-bottom: 1px solid #0000;\n            display: grid;\n            ".concat(getViewportCSS(size, fontSizeCSS), ";\n            min-height: 24px;\n            place-items: center;\n        }\n\n        &:hover span {\n            border-bottom: 1px solid var(--color-brand-dark);\n        }\n\n        &:active span {\n            border-bottom: 1px solid var(--color-global-white);\n        }\n\n        & span.notification {\n            border-radius: 8px;\n            background-color: var(--color-brand-mid);\n            color: var(--color-global-white);\n            font: var(--font-weight-paragraph) var(--font-size-m2)/var(--font-line-height-m2) var(--font-brand);\n            height: 16px;\n            min-height: var(--spacing-global-space5);\n            min-width: var(--spacing-global-space5);\n            padding: 0 4px;\n            position: absolute;\n            top: 0;\n            left: calc(50% + 4px);\n        }\n\n        &[disabled] {\n            color: var(--color-global-grey400);\n            background-color: unset;\n            border: none;\n            cursor: auto;\n        }\n\n        &[disabled] span.notification {\n            background-color: var(--color-global-grey400);\n        }\n\n        &[disabled] span {\n            border: none;\n        }\n\n        &[disabled]:hover span {\n            border-bottom: none;\n        }\n\n        &[disabled]:before {\n            background-color: var(--color-global-grey400);\n        }\n\n        &:before {\n            content: '';\n            display: inline-flex;\n            margin: 0 0 var(--spacing-global-space1);\n\t\t\t").concat(getViewportCSS(size, iconSizeCSS), "\n            mask: url('data:image/svg+xml,").concat(encodeURIComponent((0, _server.renderToStaticMarkup)(SvgIcon)), "') center/contain\n                no-repeat;\n            -webkit-mask: url('data:image/svg+xml,").concat(encodeURIComponent((0, _server.renderToStaticMarkup)(SvgIcon)), "') center/contain\n                no-repeat;\n            background: var(--color-global-black);\n        }\n\n\t\t// Minimum clickable area\n\t\t&:after {\n\t\t\tcontent: \"\";\n\t\t\tdisplay: block;\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 50%;\n\t\t\ttransform: translate(-50%, -50%);\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tmin-width: 44px;\n\t\t\tmin-height: 44px;\n\t\t}\n    ");
});